













import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import { SPACE_TYPE } from "@/resources/constants/space";
import { BOT_CHAT } from "@/resources/constants/botChat";
import { i18n } from "@/resources/locales";
import { HELP_AND_SUPPORT } from "@/resources/constants/helpAndSupport";

@Component({
  name: "sidebar-help-component",
})
export default class SidebarHelpComponent extends mixins(UserValidator) {
  BOT_CHAT = BOT_CHAT;
  get user() {
    return this.$store.getters["UserStore/getSpaceUser"];
  }
  url(): void {
    let subject = i18n.t("sidebar.footer.help").toString();
    const mailtoLink = `mailto:${encodeURIComponent(HELP_AND_SUPPORT.EMAIL)}?subject=${encodeURIComponent(subject)}`;
    window.location.href = mailtoLink;
  }
  /*get url(): string {
    if (this.user && this.isAdmin() && this.isSpaceEvent()) {
      return BOT_CHAT.EVENT_ADMIN;
    }
    if (this.user && this.isSpaceEvent()) {
      return BOT_CHAT.EVENT_USER;
    }
    if (this.user && this.isAdmin() && this.isSpaceOffice()) {
      return BOT_CHAT.OFFICE_ADMIN;
    }
    if (this.user && this.isSpaceOffice()) {
      return BOT_CHAT.OFFICE_USER;
    }
    return "";
  }*/
  isSpaceEvent() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    if (space && space.type && space.type == SPACE_TYPE.EVENT_TYPE) {
      return true;
    }
    return false;
  }
  isSpaceOffice() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    if (space && space.type && space.type == SPACE_TYPE.OFFICE_TYPE) {
      return true;
    }
    return false;
  }
}
